import { getSheet } from "./get-sheet";

let uncommittedChanges = null;
let blitzRendered = false;
let isQueued = false;

/**
 * Extracts and wipes the cache
 * @returns {String}
 */
export const extractCss = (target) => {
  const sheet = getSheet(target);
  const out = sheet.data;
  sheet.data = "";
  uncommittedChanges = "";
  return out;
};

if (typeof globalThis.addEventListener === "function") {
  globalThis.addEventListener("__BLITZ_RENDER__", () => {
    blitzRendered = true;
  });
}

// Heuristic to check if browser environment.
const isBrowser = globalThis.navigator;

/**
 * Updates the target and keeps a local cache
 * @param {String} css
 * @param {Object} sheet
 * @param {Boolean} append
 */
export function update(css, sheet, append) {
  if (!uncommittedChanges) uncommittedChanges = sheet?.data ?? "";
  if (~uncommittedChanges.indexOf(css)) return;

  uncommittedChanges = append
    ? css + uncommittedChanges
    : uncommittedChanges + css;

  if (!isBrowser || !blitzRendered) {
    commit(sheet);
  } else if (!isQueued) {
    isQueued = true;
    queueMicrotask(() => {
      isQueued = false;
      commit(sheet);
    });
  }
}

function commit(sheet) {
  if (!uncommittedChanges) return;
  if (!sheet) sheet = getSheet();
  sheet.data = uncommittedChanges;
  uncommittedChanges = null;
}
